// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-pose-metrics-dialog__subtitle {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  font-weight: 500;
  opacity: 0.75;
}

.session-pose-metrics-dialog__empty {
  margin: 12px 0;
  font-size: 14px;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/SessionPoseMetricsDialog.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd","sourcesContent":[".session-pose-metrics-dialog__subtitle {\n  display: block;\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  opacity: 0.75;\n}\n\n.session-pose-metrics-dialog__empty {\n  margin: 12px 0;\n  font-size: 14px;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
